const mapCarToForm = (car) => ({

    title: car.title || "",

    company: car.company || "",

    shasiNo: car.shasiNo || "",

    productYear: car.productYear4Edit || "",

    kilometer: car.kilometer4Edit || "",

    distancePerWeek: car.distancePerWeek4Edit || "",

    useFuel: car.useFuel4Edit || "",

    pelak1: car.pelak14Edit || "",

    pelak2: car.pelak2 || 1,

    pelak3: car.pelak34Edit || "",

    pelak4: car.pelak44Edit || "",

    imageFile: null,

    userId: car.userId || "",

});

export default mapCarToForm;